var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCurlingStone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 224C480 188.652 451.346 160 416 160H224V120C224 97.938 241.938 80 264 80H392C405.25 80 416 69.25 416 56S405.25 32 392 32H264C215.469 32 176 71.469 176 120V160H160C124.654 160 96 188.652 96 224C42.98 224 0 266.98 0 320V384C0 437.02 42.98 480 96 480H480C533.02 480 576 437.02 576 384V320C576 266.98 533.02 224 480 224ZM96 272H480C506.467 272 528 293.531 528 320V328H48V320C48 293.531 69.533 272 96 272ZM480 432H96C69.533 432 48 410.469 48 384V376H528V384C528 410.469 506.467 432 480 432Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurlingStone);
export default __webpack_public_path__ + "static/media/curling-stone.a97b55bd075c8fc0f5af11b004c1eea8.svg";
export { ForwardRef as ReactComponent };